import { createSelector } from 'reselect'

export const getArtists = state => state.users.artists.list;

export const getTotalArtists = state => state.users.artists.total;

export const getPopularArtists = state => state.users.popular;

export const getProfile = state => state.users.profile.basic;

export const getActivitiesFeed = state => state.users.profile.activities.list;

export const getActivitiesTotal = state => state.users.profile.activities.total;

export const getPublishedAlbums = state => state.users.profile.albums;

export const getPublishedSingles = state => state.users.profile.singles;

export const getPopularSongs = state => state.users.profile.popular;

export const getTotalFollowers = state => state.users.profile.followers.total;

export const getFollowers = state => state.users.profile.followers.list;

export const isFollowing = state => state.users.profile.following;

export const getPublicPlaylists = state => state.users.profile.playlists;

export const getMyPlaylists = state => state.users.current.playlists;

export const getAllUsers = state => state.users.all.list;

export const getTotalUsers = state => state.users.all.total;
